module.exports = __webpack_public_path__ + "static/media/cart.64abd846.svg";